import React, { useState, useEffect } from 'react';
import './ImagePreview.css';

interface ImagePreviewProps {
  fileName: string;
  filePath: string;
  onDimensionsLoad?: (width: number, height: number) => void;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ fileName, filePath, onDimensionsLoad }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      onDimensionsLoad?.(img.naturalWidth, img.naturalHeight);
    };
    img.src = filePath;
  }, [filePath, onDimensionsLoad]);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="image-preview">
      <img
        src={filePath}
        alt={fileName}
        onLoad={handleImageLoad}
        className={imageLoaded ? 'loaded' : ''}
      />
    </div>
  );
};

export default ImagePreview;
